var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "eu-mb_5" },
        [
          _c("emd-text", { staticClass: "lable_title" }, [
            _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
          ]),
          _c(
            "emd-text",
            {
              staticClass: "eu-mt_1",
              attrs: { size: "small", tag: "p", "variation-color": "subtle" },
            },
            [_vm._v(_vm._s(_vm.$t("subtle")))]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "eu-mb_5" }, [
        _c(
          "div",
          { staticClass: "eu-mb_3" },
          [
            _c("emd-text", { staticClass: "lable_title" }, [
              _vm._v(" " + _vm._s(_vm.$t("radio-button.title")) + " "),
            ]),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("emd-radio", {
              staticClass: "eu-mb_4",
              attrs: {
                name: "radio-permission-user",
                value: _vm.typeRead,
                label: _vm.$t("radio-button.read-only"),
              },
              model: {
                value: _vm.scope,
                callback: function ($$v) {
                  _vm.scope = $$v
                },
                expression: "scope",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("emd-radio", {
              staticClass: "_bold",
              attrs: {
                name: "radio-permission-user",
                value: _vm.typeReadWrite,
                label: _vm.$t("radio-button.read-write"),
              },
              model: {
                value: _vm.scope,
                callback: function ($$v) {
                  _vm.scope = $$v
                },
                expression: "scope",
              },
            }),
          ],
          1
        ),
      ]),
      _c("hr", { staticClass: "emd-divider" }),
      _c("password-confirmation", {
        staticClass: "eu-mt_5",
        attrs: { label: "", "has-error": _vm.authError },
        model: {
          value: _vm.password,
          callback: function ($$v) {
            _vm.password = $$v
          },
          expression: "password",
        },
      }),
      _c(
        "div",
        { staticClass: "create-key__footer" },
        [
          _c(
            "emd-button",
            {
              attrs: {
                type: "outline",
                color: "primary",
                "data-testid": "close-modal",
              },
              on: { click: _vm.handleBack },
            },
            [_vm._v(" " + _vm._s(_vm.$t("general.back")) + " ")]
          ),
          _c(
            "emd-button",
            {
              attrs: {
                color: "primary",
                "data-testid": "create",
                type: "submit",
                disabled: _vm.computedDisabled,
              },
            },
            [
              _vm.isLoading
                ? _c("emd-loader")
                : _c("span", [
                    _vm._v(" " + _vm._s(_vm.$t("form.button.create")) + " "),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }